import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/modules/core/store/app.state';
import { LoggedInModuleType } from '@app/modules/shared/interfaces/logged-in-module.type';
import { LoginResponse } from '@app/modules/shared/interfaces/login-response.type';
import { HelperService } from '@app/services/helper.service';
import { LoggingService, LogLevel } from '@app/services/logging.service';
import { Store } from '@ngrx/store';
import { Observable, map, shareReplay } from 'rxjs';
import { environment as env } from 'environments/environment';
import * as AuthActions from '../../modules/core/store/actions/auth.actions';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-verify-login-token',
    templateUrl: './verify-login-token.component.html',
    styleUrl: './verify-login-token.component.scss',
    standalone: false
})
export class VerifyLoginTokenComponent {
  static readonly COMPONENT_NAME = 'VerifyLoginTokenComponent';
  loggingService = inject(LoggingService);

  errorMessage = '';
  loaded: any;
  s3Url = '';
  isMobile: boolean = false;
  loginResponse!: LoginResponse;
  loading = true;
  token!: string;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.TabletPortrait])
    .pipe(
      map(result => {
        console.log("== result ==", result);
        return result.matches;
      }),
      shareReplay()
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>,
    private helper: HelperService,
  ) {
    this.s3Url = env?.bucketUrl;
  }

  ngOnInit(): void {
    this.isHandset$.subscribe(r => {
      console.log('IS HANDSET:', r);
      this.isMobile = r;
    });

    this.route.queryParams.subscribe((qp) => {
      if (qp['token'] && qp['token'] != '') {
        this.token = qp['token'];
        this.verifyLoginToken();
        this.loggingService.log(LogLevel.DEBUG, VerifyLoginTokenComponent.COMPONENT_NAME, 'ngOnInit: token:', this.token);
      } else {
        this.router.navigateByUrl('/login');
      }
    });
  }

  verifyLoginToken(){
    this.loading = true;
    const observer = {
      next: (loginResponse: LoginResponse) => {
        console.log('verifyLoginToken:', loginResponse);
        let loggedInModule: LoggedInModuleType;
        loggedInModule = loginResponse.roles[0];    // When there is only one role, just choose that....
        this.store.dispatch(AuthActions.loginSuccess({
          accessToken: loginResponse.accessToken,
          refreshToken: loginResponse.refreshToken,
          user: loginResponse.user,
          loggedInModule: loggedInModule,
          // Magic-link verification — the user didn't get to tick a
          // "Remember Me" box, and the link may have been opened on a
          // device that isn't theirs. Default to a tab-scoped session.
          rememberMe: false,
        }));
        this.loggingService.log(LogLevel.DEBUG, VerifyLoginTokenComponent.COMPONENT_NAME, 'verifyLoginToken: token:', this.token);
      },
      error: (err: HttpErrorResponse) => {
        this.errorMessage = 'OOps! Something went wrong.'
        this.loading = false;
        this.helper.showHttpErrorMsg(err);
      },
      complete: () => {
        this.loading = false;
      }
    };
    this.helper.verifyLoginToken(this.token).subscribe(observer);
  }
}
